// Shimmer placeholder grid shown while the product catalog loads.
// Matches ProductCard dimensions so the layout doesn't jump on swap.
export default function GridSkeleton({ count = 8 }) {
  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
      data-testid="grid-skeleton"
      aria-hidden="true"
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={`skeleton-${i}`}
          className="rounded-2xl overflow-hidden h-[280px] sm:h-[350px] lg:h-[420px] skeleton-shimmer"
        />
      ))}
    </div>
  );
}
